import script from "./DBOptionsAccordionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBOptionsAccordionItem.vue?vue&type=script&setup=true&lang=ts"

import "./DBOptionsAccordionItem.vue?vue&type=style&index=0&id=104e46ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104e46ae"]])

export default __exports__